module.exports = __webpack_public_path__ + "img/personInfo.75e33a0a.svg";